import { MOVES } from "../data/moves";
import type { Move } from "../types";

export class AIController {
  pickMove(): Move {
    const idx = Math.floor(Math.random() * MOVES.length);
    return MOVES[idx];
  }
}
